import React from "react";
import WeekDayButton from "../Button/WeekDayButton";
import AvailabilityEditor from "./AvailabilityEditor";

const dayArray = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default function MyAvailabilitySection({
  t,
  ChangeImage,
  setIsAvailableTimeChange,
  isAvailableTimeChange,
  parsedUserProfile,
  allBookedSlots,
  transform_timezone,
  initialBookedSlots,
  selectedSlots,
  toggleSlot,
  saveTimeSlots,
}) {
  // Generate hours array based on affiliation
  const hoursArray = parsedUserProfile?.affiliation === 'FUHSD'
    ? Array.from({ length: 32 }, (_, i) => {
        const totalMinutes = 6 * 60 + i * 30; // Start at 6:00 AM, add 30 minutes per iteration
        const hour = Math.floor(totalMinutes / 60);
        const minute = totalMinutes % 60;
        return `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
      }) // 6:00 AM to 9:30 PM every 30 minutes
    : Array.from({ length: 24 }, (_, i) => `${i.toString().padStart(2, "0")}:00`); // 0:00 AM to 11:00 PM
  return (
    <>
      <div id="section3" className="relative w-full text-center mt-10">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300"></div>
        </div>
        <span className="relative bg-[var(--bg)] px-3 text-lg font-bold text-[var(--brand)] uppercase tracking-wider">
          {t("user_home.my_avail")}
        </span>
      </div>
      <div className="flex justify-end">
        <button>
          <img
            src={ChangeImage}
            alt="addTimeslot"
            className="md:w-[40px] md:h-[40px]"
            onClick={(e) => setIsAvailableTimeChange(true)}
          />
        </button>
      </div>

      {!isAvailableTimeChange ? (
        <>
          <div className="flex justify-center">
            {t("user_home.add_time_slot")}
          </div>
          <div className="flex justify-center">
            {t("meeting.table_text")}{" "}
            <span style={{ color: "red" }}>
              {" "}
              {t(transform_timezone(parsedUserProfile?.timezone))}{" "}
            </span>
          </div>
          <div className="overflow-x-scroll md:overflow-auto -mx-4 md:mx-0">
            <div className="grid grid-cols-7 p-4 py-[47px] md:px-4 lg:px-28 xl:px-[220px] min-w-[800px] md:min-w-0 md:w-full">
              {dayArray.map((day) => (
                <div key={day} className="flex flex-col items-center">
                  <WeekDayButton name={day} />
                  <div className="space-y-2 mt-3">
                    {allBookedSlots[day]?.length > 0 ? (
                      allBookedSlots[day].map((time, index) => (
                        <div
                          key={index}
                          className="text-center px-4 py-2 bg-white text-gray-700 border border-gray-300 rounded font-semibold"
                        >
                          {time}
                        </div>
                      ))
                    ) : (
                      <div className="text-gray-700 text-md font-semibold">
                        No slots
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : null}
      {isAvailableTimeChange && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg w-11/12 md:w-1/2 lg:w-[50.666667%] max-h-[80vh] overflow-y-auto p-6 relative">
            <button
              className="absolute top-3 right-4 text-gray-500 hover:text-black"
              onClick={() => setIsAvailableTimeChange(false)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <AvailabilityEditor
              t={t}
              parsedUserProfile={parsedUserProfile}
              transform_timezone={transform_timezone}
              dayArray={dayArray}
              hoursArray={hoursArray}
              initialBookedSlots={initialBookedSlots}
              selectedSlots={selectedSlots}
              toggleSlot={toggleSlot}
              saveTimeSlots={saveTimeSlots}
            />
          </div>
        </div>
      )}
    </>
  );
}
